<template>
  <b-server-table
    :key="renderKey"
    :filter-props="{
      filterMap: [
        { key: 'search' },
        {
          key: 'statusId',
          directory: 'taskStatuses',
          component: 'select',
        },
        {
          key: 'completedDate',
          dateRageKey: ['completedStartDate', 'completedEndDate'],
          component: 'input-date-range',
        },
        {
          key: 'deadline',
          dateRageKey: ['deadlineStartDate', 'deadlineEndDate'],
          component: 'input-date-range',
        },
      ],
    }"
    :headers="taskHeaders"
    :request-func="getObserverUsers"
    @click:row="openRow">
    <template #action-button>
      <printed-form></printed-form>
    </template>
    <template #item.status="{ item }">
      <v-chip
        v-if="item.status"
        :color="getStatusColor(item.status.id)"
        size="small"
        variant="flat"
        >{{ item.status?.name }}
      </v-chip>
    </template>
    <template #item.deadline="{ item }">
      <v-chip v-if="item.isOverdue" color="red" size="small">
        {{
          new CustomDate(item.deadline).toString({
            time: true,
            format: 'locale-hybrid',
          })
        }}
      </v-chip>
      <span v-else>{{
        new CustomDate(item.deadline).toString({
          time: true,
          format: 'locale-hybrid',
        })
      }}</span>
    </template>
    <template #item.executor="{ item }">
      <span>{{
        getPersonName(item.executor, { initials: true }) || '---'
      }}</span>
    </template>
    <template #item.topic="{ item }">
      <span
        v-tooltip:bottom="item.topic"
        style="
          display: block;
          width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        "
        >{{ item?.topic || '---' }}
      </span>
    </template>
    <template #item.author="{ item }">
      <span>{{ getPersonName(item.author, { initials: true }) || '---' }}</span>
    </template>
    <template #item.completedDate="{ item }">
      <div class="d-flex align-center gap-3">
        <span>{{
          new CustomDate(item.completedDate).toString({ time: true }) || '---'
        }}</span>
        <v-menu v-if="item.completedDate" open-on-hover>
          <template #activator="{ props }">
            <v-btn
              density="compact"
              icon="mdi-information-variant"
              size="small"
              v-bind="props"
              variant="plain"></v-btn>
          </template>

          <v-card>
            <v-card-text>
              {{ item.completionReport || item.rejectComment }}
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </template>
    <template #item.connect="{ item }">
      <span
        v-if="item.entityTypeId && item.entityCustomId"
        class="link"
        @click.stop="
          $router.push({
            name:
              item.entityTypeId === 3
                ? 'single-order'
                : item.entityTypeId === 9
                ? 'audit-single'
                : 'correspondence-single',
            params: { id: item.entityCustomId },
          })
        ">
        <span v-if="item.entityTypeId === 3">Наказ</span>
        <span v-else-if="item.entityTypeId === 9">Аудит</span>
        <span v-else>Кореспонденція</span>
      </span>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
    <template #[`item.contractor`]="{ item }">
      <v-tooltip v-if="item.contractor" :text="item.contractor?.name" bottom>
        <template #activator="{ props }">
          <span
            class="link"
            style="
              display: block;
              width: 230px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            "
            v-bind="props"
            @click.stop="
              $router.push({
                name: 'single-contractor',
                params: { id: item?.contractor?.id },
              })
            "
            >{{ item.contractor?.name }}</span
          >
        </template>
      </v-tooltip>
      <v-icon v-else>{{ 'mdi-minus' }}</v-icon>
    </template>
  </b-server-table>
</template>

<script lang="ts">
import { ref } from 'vue'
import { navigateToItem } from '@/utils/helpers'
import { taskHeaders } from '@/utils/tableHeaders'
import PrintedForm from '@/pages/task/single/components/PrintedForm.vue'
import { BServerTable } from 'best-modules/components/index'
import { CustomDate, getPersonName } from 'best-modules/utils'
import { taskObserverList } from '@/requests/task'

export default {
  name: 'ObserverList',
  components: {
    PrintedForm,
    BServerTable,
  },
  data: () => {
    return {
      taskHeaders,
    }
  },
  methods: { getPersonName, CustomDate },
  setup() {
    const renderKey = ref(1)

    const openRow = (event: any) => {
      navigateToItem('single-task', event.id)
    }

    const getObserverUsers = (query: any) => taskObserverList(query)

    const getStatusColor = (statusId: any) => {
      switch (statusId) {
        case 1:
          return 'yellow-lighten-1'
        case 2:
          return 'blue'
        case 3:
          return 'green'
        case 4:
          return 'red'
        case 5:
          return 'yellow-lighten-1'
      }
    }

    return {
      getObserverUsers,
      renderKey,
      openRow,
      getStatusColor,
    }
  },
}
</script>

<style lang="scss" scoped></style>
